import positionOverview from "../PositionOverview";
//阵地总览
export  const  positionOverviewRoute =[
    {
        path: "/newMedia/positionOverview",
        component: positionOverview
    },
];